angular.module('core').filter('nullableMinutes', [ 'numberFilter',
  function($numberFilter) {

    return function(milliseconds) {
      if(_.isUndefined(milliseconds) || !_.isNumber(milliseconds)) {
        return 'N/A';
      }
      else {
        return $numberFilter(Math.floor((milliseconds / 1000) / 60)) + ' min';
      }
    };

  }
]);
